import ValidationErrors from '../fields/validationErrors';
import { ValidatorRule, ValidatorResult } from './validatorRule.constants';
import { BaseValidator } from './baseValidator';

export class FirstNameFieldValidator extends BaseValidator {
    public EUFirstNameLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 255;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'EUFirstNameLengthRule',
            };
        }
        return null;
    }

    public JPFirstNameLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 85;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'JPFirstNameLengthRule',
            };
        }
        return null;
    }

    constructor(rules = [ValidatorRule.EUFirstNameLengthRule]) {
        super(rules);
    }
}
